import {HttpError, httpErrorHandler} from "@/services/api/error/HttpError";

export function responseHandler(response) {
    const config = response.config;

    if (config.raw) {
        return response;
    }

    if (response.status === 200) {
        const data = response.data;

        if (!data) {
            throw new HttpError('No data')
        }

        return data;
    }
}

export function responseErrorHandler(response) {
    const config = response.config;

    if (config.raw) {
        return response;
    }

    return httpErrorHandler(response);
}
